@if (!isMorphed) {
  @if (showBackground) {
    <span data-background aria-hidden="true"></span>
  }
  <img data-wordmark [src]="wordmarkSrc" [attr.alt]="emptyAlt" [attr.aria-hidden]="'true'" />
  <span data-version>{{ version }}</span>
  <span data-version-cursor aria-hidden="true"></span>
}
<img data-symbol [src]="symbolSrc" [attr.alt]="emptyAlt" [attr.aria-hidden]="'true'" />
